//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AnchorPointSecond",1,"Point",0],[1,"AngularLowerLimit",0,"Expression",0],[1,"AngularUpperLimit",0,"Expression",0],[0,"BaseAnchorPoint",1,"Point",0],[0,"BaseAxisVector",1,"Direction",0],[0,"EnableAngularLowerLimit",1,0],[0,"EnableAngularUpperLimit",1,0],[0,"EnableSecondAnchor",1,0],[1,"Geometry",0,"SelectNXObjectList",0],[0,"Name",1,0],[1,"StartAngle",0,"Expression",0]],[],[]];
SPLM.Mechatronics.ChainJointBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ChainJointBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;